<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Dashboard Admisión",
            cargando: false,
            cargandoPerformance: false,
            actualizandoDia: false,
            actualizandoPerformance: false,
            mensajeActualizacionDia: "",
            mensajePerformance: "",
            error: "",
            periodo: "",
            programa: "todos",
            dailyRange: "dia",
            periodOptions: [],
            programOptions: [],
            syncedAt: null,
            syncedTime: null,
            performanceSyncedTime: null,
            kpis: {
                leads: 0,
                oportunidades: 0,
                postulados: 0,
                matriculados: 0,
                conversion: 0,
                meta_total: 0,
                cumplimiento: 0
            },
            trend: [],
            dailyManagement: {
                date: null,
                range: "dia",
                range_label: "el día",
                from: null,
                to: null,
                updated_at: null,
                updated_time: null,
                items: []
            },
            dailyRangeOptions: [
                { key: "dia", label: "Día" },
                { key: "semana", label: "Semana" },
                { key: "mes", label: "Mes" }
            ],
            performance: {
                summary: {
                    total_leads: 0,
                    matriculados: 0,
                    conversion_rate: 0,
                    average_close_days: 0,
                    close_samples: 0,
                    stage_history_available: false
                },
                by_career: [],
                by_owner: [],
                by_source: [],
                owner_careers: [],
                stage_times: [],
                matriculation_days: [],
                trend: []
            },
            items: [
                {
                    text: "Dashboard",
                    href: "/"
                },
                {
                    text: "Dashboard Admisión",
                    active: true
                }
            ]
        };
    },
    computed: {
        trendMax() {
            return Math.max(1, ...this.trend.map(item => Number(item.total || 0)));
        },
        dailyManagementMax() {
            return Math.max(1, ...this.dailyManagement.items.map(item => Number(item.total || 0)));
        },
        dailyManagementRangeText() {
            const from = this.dailyManagement.from || this.dailyManagement.date;
            const to = this.dailyManagement.to || this.dailyManagement.date;

            if (!from || !to || from === to) {
                return this.formatShortDate(from);
            }

            return `${this.formatShortDate(from)} - ${this.formatShortDate(to)}`;
        },
        performanceCareerMax() {
            return Math.max(1, ...this.performance.by_career.map(item => Number(item.total || 0)));
        },
        performanceOwnerMax() {
            return Math.max(1, ...this.performance.by_owner.map(item => Number(item.total || 0)));
        },
        performanceSourceMax() {
            return Math.max(1, ...this.performanceSourceGroups.map(item => Number(item.total || 0)));
        },
        performanceSourceGroups() {
            const groups = new Map();
            const standalone = [];

            this.performance.by_source.forEach(item => {
                if (!item.parent_label) {
                    standalone.push({ ...item, children: [] });
                    return;
                }

                if (!groups.has(item.parent_label)) {
                    groups.set(item.parent_label, {
                        label: item.parent_label,
                        total: 0,
                        matriculados: 0,
                        conversion_rate: 0,
                        children: []
                    });
                }

                const group = groups.get(item.parent_label);
                group.total += Number(item.total || 0);
                group.matriculados += Number(item.matriculados || 0);
                group.children.push(item);
            });

            groups.forEach(group => {
                group.conversion_rate = group.total > 0
                    ? (group.matriculados / group.total) * 100
                    : 0;
                group.children = this.sortPerformanceByConversion(group.children);
            });

            return this.sortPerformanceByConversion([...standalone, ...groups.values()]);
        },
        performanceDayMax() {
            return Math.max(1, ...this.performance.matriculation_days.map(item => Number(item.total || 0)));
        },
        selectedProgramLabel() {
            const option = this.programOptions.find(item => item.key === this.programa);

            return option ? option.label : this.programa;
        },
        filtersDisabled() {
            return this.cargando || this.cargandoPerformance || this.actualizandoDia || this.actualizandoPerformance;
        }
    },
    mounted() {
        this.cargarTodoDashboard();
    },
    methods: {
        async cargarTodoDashboard() {
            this.mensajeActualizacionDia = "";
            this.mensajePerformance = "";

            await Promise.all([
                this.cargarDashboard(),
                this.cargarPerformance()
            ]);
        },
        async cargarDashboard() {
            this.cargando = true;
            this.error = "";

            try {
                const params = {
                    programa: this.programa,
                    gestion_rango: this.dailyRange,
                    include_performance: false
                };
                if (this.periodo) {
                    params.periodo = this.periodo;
                }
                const { data } = await axios.get("/api/dashboard/admision/direccion", { params });

                this.aplicarDashboardData(data);
            } catch (error) {
                this.error = (error.response && error.response.data && error.response.data.message) || "No se pudo cargar el Dashboard Admisión.";
            } finally {
                this.cargando = false;
            }
        },
        aplicarDashboardData(data) {
            this.periodo = data.periodo || this.periodo;
            this.programa = data.programa || this.programa;
            this.periodOptions = Array.isArray(data.period_options) ? data.period_options : [];
            this.programOptions = Array.isArray(data.program_options) ? data.program_options : [];
            this.syncedAt = data.synced_at || null;
            this.syncedTime = data.synced_time || null;
            this.kpis = {
                leads: Number(data.kpis && data.kpis.leads || 0),
                oportunidades: Number(data.kpis && data.kpis.oportunidades || 0),
                postulados: Number(data.kpis && data.kpis.postulados || 0),
                matriculados: Number(data.kpis && data.kpis.matriculados || 0),
                conversion: Number(data.kpis && data.kpis.conversion || 0),
                meta_total: Number(data.kpis && data.kpis.meta_total || 0),
                cumplimiento: Number(data.kpis && data.kpis.cumplimiento || 0)
            };
            this.trend = Array.isArray(data.trend) ? data.trend.map(item => ({
                fecha: item.fecha || "",
                total: Number(item.total || 0)
            })) : [];
            this.dailyManagement = {
                date: data.daily_management && data.daily_management.date || null,
                range: data.daily_management && data.daily_management.range || this.dailyRange,
                range_label: data.daily_management && data.daily_management.range_label || "el día",
                from: data.daily_management && data.daily_management.from || null,
                to: data.daily_management && data.daily_management.to || null,
                updated_at: data.daily_management && data.daily_management.updated_at || null,
                updated_time: data.daily_management && data.daily_management.updated_time || null,
                items: data.daily_management && Array.isArray(data.daily_management.items) ? data.daily_management.items.map(item => ({
                    key: item.key || item.label,
                    label: item.label || "Sin etiqueta",
                    total: Number(item.total || 0)
                })) : []
            };
            this.dailyRange = this.dailyManagement.range || this.dailyRange;
        },
        async cargarPerformance() {
            this.cargandoPerformance = true;
            this.error = "";

            try {
                const params = { programa: this.programa };
                if (this.periodo) {
                    params.periodo = this.periodo;
                }
                const { data } = await axios.get("/api/dashboard/admision/performance", { params });

                this.aplicarPerformanceData(data);
            } catch (error) {
                this.error = (error.response && error.response.data && error.response.data.message) || "No se pudo cargar Performance.";
            } finally {
                this.cargandoPerformance = false;
            }
        },
        aplicarPerformanceData(data) {
            this.performanceSyncedTime = data.synced_time || null;
            this.periodOptions = Array.isArray(data.period_options) ? data.period_options : this.periodOptions;
            this.programOptions = Array.isArray(data.program_options) ? data.program_options : this.programOptions;
            const performance = data.performance || {};
            this.performance = {
                current_week: performance.current_week || null,
                summary: {
                    total_leads: Number(performance.summary && performance.summary.total_leads || 0),
                    matriculados: Number(performance.summary && performance.summary.matriculados || 0),
                    conversion_rate: Number(performance.summary && performance.summary.conversion_rate || 0),
                    average_close_days: Number(performance.summary && performance.summary.average_close_days || 0),
                    close_samples: Number(performance.summary && performance.summary.close_samples || 0),
                    stage_history_available: Boolean(performance.summary && performance.summary.stage_history_available)
                },
                by_career: this.normalizePerformanceList(performance.by_career),
                by_owner: this.normalizePerformanceList(performance.by_owner),
                by_source: this.normalizePerformanceList(performance.by_source),
                owner_careers: this.normalizeOwnerCareers(performance.owner_careers),
                stage_times: Array.isArray(performance.stage_times) ? performance.stage_times.map(item => ({
                    stage: item.stage || "Sin etapa",
                    average_days: Number(item.average_days || 0),
                    samples: Number(item.samples || 0)
                })) : [],
                matriculation_days: Array.isArray(performance.matriculation_days) ? performance.matriculation_days.map(item => ({
                    day: item.day || "Sin fecha",
                    total: Number(item.total || 0),
                    percentage: Number(item.percentage || 0)
                })) : [],
                trend: Array.isArray(performance.trend) ? performance.trend.map(item => ({
                    fecha: item.fecha || "",
                    total: Number(item.total || 0),
                    average_days: Number(item.average_days || 0)
                })) : []
            };
        },
        normalizePerformanceList(items) {
            return Array.isArray(items) ? this.sortPerformanceByConversion(items.map(item => ({
                source_value: item.source_value || null,
                label: item.label || "Sin etiqueta",
                parent_label: item.parent_label || null,
                total: Number(item.total || 0),
                matriculados: Number(item.matriculados || 0),
                matriculados_semana: item.matriculados_semana == null ? null : Number(item.matriculados_semana),
                conversion_rate: Number(item.conversion_rate || 0)
            }))) : [];
        },
        normalizeOwnerCareers(items) {
            return Array.isArray(items) ? items.map(item => ({
                label: item.label || "Sin coordinador",
                total: Number(item.total || 0),
                careers: Array.isArray(item.careers) ? this.sortPerformanceByConversion(item.careers.map(career => ({
                    label: career.label || "Sin carrera",
                    total: Number(career.total || 0),
                    percentage: Number(career.percentage || 0)
                })), "percentage", "total") : []
            })).sort((left, right) => {
                const totalDiff = Number(right.total || 0) - Number(left.total || 0);
                if (totalDiff !== 0) {
                    return totalDiff;
                }

                return String(left.label || "").localeCompare(String(right.label || ""), "es");
            }) : [];
        },
        sortPerformanceByConversion(items, rateKey = "conversion_rate", volumeKey = "matriculados") {
            return [...items].sort((left, right) => {
                const rateDiff = Number(right[rateKey] || 0) - Number(left[rateKey] || 0);
                if (rateDiff !== 0) {
                    return rateDiff;
                }

                const volumeDiff = Number(right[volumeKey] || 0) - Number(left[volumeKey] || 0);
                if (volumeDiff !== 0) {
                    return volumeDiff;
                }

                return String(left.label || "").localeCompare(String(right.label || ""), "es");
            });
        },
        formatNumber(value) {
            return Number(value || 0).toLocaleString("es-CL");
        },
        formatPercentage(value) {
            return `${Number(value || 0).toLocaleString("es-CL", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            })}%`;
        },
        formatDays(value) {
            return `${Number(value || 0).toLocaleString("es-CL", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            })} días`;
        },
        formatWeekDate(value) {
            return value ? String(value).split('-').reverse().join('/') : '-';
        },
        formatDate(value) {
            if (!value) {
                return "-";
            }

            const normalized = String(value).replace(" ", "T");
            const date = new Date(`${normalized}Z`);
            if (Number.isNaN(date.getTime())) {
                return value;
            }

            return date.toLocaleString("es-CL", {
                timeZone: "America/Santiago",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit"
            });
        },
        formatShortDate(value) {
            if (!value) {
                return "-";
            }

            const date = new Date(`${value}T12:00:00`);
            if (Number.isNaN(date.getTime())) {
                return value;
            }

            return date.toLocaleDateString("es-CL", {
                day: "2-digit",
                month: "2-digit"
            });
        },
        formatTime(value) {
            if (!value) {
                return "-";
            }

            const normalized = String(value).replace(" ", "T");
            const date = new Date(`${normalized}Z`);
            if (Number.isNaN(date.getTime())) {
                return value;
            }

            return date.toLocaleTimeString("es-CL", {
                timeZone: "America/Santiago",
                hour: "2-digit",
                minute: "2-digit"
            });
        },
        barWidth(total, max) {
            return `${Math.max(4, Math.round((Number(total || 0) / Math.max(1, max)) * 100))}%`;
        },
        async actualizarGestionDiaria() {
            if (this.actualizandoDia) {
                return;
            }

            this.actualizandoDia = true;
            this.mensajeActualizacionDia = `Actualizando datos de ${this.dailyManagement.range_label || "el rango"} desde HubSpot...`;
            this.error = "";

            try {
                const { data } = await axios.post("/api/dashboard/admision/direccion/actualizar-dia", {
                    periodo: this.periodo,
                    programa: this.programa || "todos",
                    fecha: this.dailyManagement.date || this.fechaHoy(),
                    gestion_rango: this.dailyRange,
                    include_performance: false
                });

                if (data.dashboard) {
                    this.aplicarDashboardData(data.dashboard);
                } else {
                    await this.cargarDashboard();
                }

                this.mensajeActualizacionDia = data.message || "Datos actualizados.";
            } catch (error) {
                this.mensajeActualizacionDia = (error.response && error.response.data && error.response.data.message) || "No se pudo iniciar la actualización del día.";
            } finally {
                this.actualizandoDia = false;
            }
        },
        async actualizarPerformance() {
            if (this.actualizandoPerformance) {
                return;
            }

            this.actualizandoPerformance = true;
            this.mensajePerformance = "Actualizando Performance desde HubSpot...";
            this.error = "";

            try {
                const { data } = await axios.post("/api/dashboard/admision/performance/actualizar", {
                    periodo: this.periodo,
                    programa: this.programa,
                    include_performance: false
                });

                if (data.performance_dashboard) {
                    this.aplicarPerformanceData(data.performance_dashboard);
                } else {
                    await this.cargarPerformance();
                }

                if (data.dashboard && data.dashboard.periodo === this.periodo && data.dashboard.programa === this.programa) {
                    this.aplicarDashboardData(data.dashboard);
                }

                this.mensajePerformance = data.message || "Performance actualizado.";
            } catch (error) {
                this.mensajePerformance = (error.response && error.response.data && error.response.data.message) || "No se pudo actualizar Performance.";
            } finally {
                this.actualizandoPerformance = false;
            }
        },
        fechaHoy() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const day = String(now.getDate()).padStart(2, "0");

            return `${year}-${month}-${day}`;
        },
        dailyCardClass(key) {
            if (["sin_asignar", "sin_contactar", "sin_actividad"].indexOf(key) !== -1) {
                return "dashboard-admission-daily-warning";
            }

            if (key === "matriculas_rango") {
                return "dashboard-admission-daily-success";
            }

            return "";
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div v-if="error" class="alert alert-danger">
            <i class="bx bx-error-circle mr-1"></i>
            {{ error }}
        </div>

        <div class="card dashboard-admission-controls-section border-0 shadow-sm mb-3">
            <div class="card-body">
                <div class="dashboard-admission-controls-header">
                    <div>
                        <h5 class="mb-1">Filtros del dashboard</h5>
                        <small class="text-muted">{{ periodo }} · {{ selectedProgramLabel }}</small>
                    </div>
                    <div class="dashboard-admission-filters mt-3 mt-md-0">
                        <label>
                            <span>Período</span>
                            <select v-model="periodo" class="custom-select custom-select-sm" :disabled="filtersDisabled" @change="cargarTodoDashboard">
                                <option v-for="option in periodOptions" :key="option" :value="option">{{ option }}</option>
                            </select>
                        </label>
                        <label>
                            <span>Programa</span>
                            <select v-model="programa" class="custom-select custom-select-sm" :disabled="filtersDisabled" @change="cargarTodoDashboard">
                                <option v-for="option in programOptions" :key="option.key" :value="option.key">{{ option.label }}</option>
                            </select>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="card dashboard-admission-daily-section border-0 shadow-sm mb-3">
            <div class="card-body">
                <div class="dashboard-admission-section-header mb-3">
                    <div>
                        <h5 class="mb-1">Gestión Comercial Diaria</h5>
                        <small class="text-muted">{{ dailyManagementRangeText }} · Actualizado {{ dailyManagement.updated_time || '-' }}</small>
                    </div>
                    <div class="dashboard-admission-daily-actions">
                        <select v-model="dailyRange" class="custom-select custom-select-sm" :disabled="cargando || actualizandoDia" @change="cargarDashboard">
                            <option v-for="option in dailyRangeOptions" :key="option.key" :value="option.key">{{ option.label }}</option>
                        </select>
                        <button type="button" class="btn btn-sm btn-primary" :disabled="cargando || actualizandoDia" @click="actualizarGestionDiaria">
                            <i class="bx" :class="actualizandoDia ? 'bx-loader-alt bx-spin' : 'bx-refresh'"></i>
                            <span>{{ actualizandoDia ? 'Actualizando' : 'Actualizar' }}</span>
                        </button>
                    </div>
                </div>

                <div v-if="mensajeActualizacionDia" class="alert dashboard-admission-daily-status mb-3" :class="actualizandoDia ? 'alert-info' : 'alert-light'">
                    {{ mensajeActualizacionDia }}
                </div>

                <div class="dashboard-admission-daily-grid">
                    <div v-for="item in dailyManagement.items" :key="item.key" class="dashboard-admission-daily-card" :class="dailyCardClass(item.key)">
                        <div class="dashboard-admission-daily-card-header">
                            <span>{{ item.label }}</span>
                        </div>
                        <strong>{{ formatNumber(item.total) }}</strong>
                        <div class="dashboard-admission-daily-track">
                            <div class="dashboard-admission-daily-bar" :style="{ width: barWidth(item.total, dailyManagementMax) }"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card dashboard-admission-direction-section border-0 shadow-sm mb-3">
            <div class="card-body">
                <div class="dashboard-admission-section-header mb-3">
                    <div>
                        <h4 class="mb-1">Dirección Admisión</h4>
                        <small class="text-muted">{{ periodo }} · {{ selectedProgramLabel }}</small>
                    </div>
                </div>

                <div class="row dashboard-admission-kpi-grid">
                    <div class="col-md-6 col-xl-3 mb-3">
                        <div class="dashboard-admission-kpi">
                            <span>Leads</span>
                            <strong>{{ formatNumber(kpis.leads) }}</strong>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-3">
                        <div class="dashboard-admission-kpi">
                            <span>Oportunidades</span>
                            <strong>{{ formatNumber(kpis.oportunidades) }}</strong>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-3">
                        <div class="dashboard-admission-kpi">
                            <span>Postulados</span>
                            <strong>{{ formatNumber(kpis.postulados) }}</strong>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-3">
                        <div class="dashboard-admission-kpi dashboard-admission-kpi-primary">
                            <span>Matriculados</span>
                            <strong>{{ formatNumber(kpis.matriculados) }}</strong>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-3">
                        <div class="dashboard-admission-kpi">
                            <span>Conversión</span>
                            <strong>{{ formatPercentage(kpis.conversion) }}</strong>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-3">
                        <div class="dashboard-admission-kpi">
                            <span>Meta</span>
                            <strong>{{ formatNumber(kpis.meta_total) }}</strong>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-3">
                        <div class="dashboard-admission-kpi">
                            <span>Cumplimiento</span>
                            <strong>{{ formatPercentage(kpis.cumplimiento) }}</strong>
                        </div>
                    </div>
                </div>

                <div class="dashboard-admission-trend-panel">
                    <div class="d-flex flex-wrap justify-content-between align-items-start mb-3">
                        <div>
                            <h5 class="mb-1">Tendencia de matrículas</h5>
                            <small class="text-muted">Cierres diarios registrados localmente.</small>
                        </div>
                        <small class="text-muted mt-2 mt-md-0">Actualizado: {{ formatDate(syncedAt) }}</small>
                    </div>
                    <div v-if="trend.length" class="dashboard-admission-trend">
                        <div v-for="item in trend" :key="item.fecha" class="dashboard-admission-trend-item">
                            <div class="dashboard-admission-trend-bar" :style="{ height: barWidth(item.total, trendMax) }">
                                <span>{{ formatNumber(item.total) }}</span>
                            </div>
                            <small>{{ formatShortDate(item.fecha) }}</small>
                        </div>
                    </div>
                    <div v-else class="dashboard-admission-empty">
                        Sin matrículas diarias registradas para este filtro.
                    </div>
                </div>
            </div>
        </div>

        <div class="card dashboard-admission-performance-section border-0 shadow-sm mb-3">
            <div class="card-body">
                <div class="dashboard-admission-section-header mb-3">
                    <div>
                        <h5 class="mb-1">Performance</h5>
                        <small class="text-muted">{{ periodo }} · {{ selectedProgramLabel }} · Actualizado {{ performanceSyncedTime || '-' }}</small>
                    </div>
                    <div class="dashboard-admission-performance-controls mt-3 mt-md-0">
                        <button type="button" class="btn btn-sm btn-primary" :disabled="cargandoPerformance || actualizandoPerformance" @click="actualizarPerformance">
                            <i class="bx" :class="actualizandoPerformance ? 'bx-loader-alt bx-spin' : 'bx-refresh'"></i>
                            <span>{{ actualizandoPerformance ? 'Actualizando' : 'Actualizar Performance' }}</span>
                        </button>
                    </div>
                </div>

                <div v-if="mensajePerformance" class="alert dashboard-admission-daily-status mb-3" :class="actualizandoPerformance ? 'alert-info' : 'alert-light'">
                    {{ mensajePerformance }}
                </div>

                <div class="dashboard-admission-performance-summary mb-3">
                    <div class="dashboard-admission-performance-kpi">
                        <span>Conversión total</span>
                        <strong>{{ formatPercentage(performance.summary.conversion_rate) }}</strong>
                    </div>
                    <div class="dashboard-admission-performance-kpi">
                        <span>Vida promedio lead</span>
                        <strong>{{ formatDays(performance.summary.average_close_days) }}</strong>
                    </div>
                    <div class="dashboard-admission-performance-kpi">
                        <span>Muestra cierre</span>
                        <strong>{{ formatNumber(performance.summary.close_samples) }}</strong>
                    </div>
                    <div class="dashboard-admission-performance-kpi">
                        <span>Matriculados</span>
                        <strong>{{ formatNumber(performance.summary.matriculados) }}</strong>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xl-4 mb-3">
                        <div class="dashboard-admission-performance-panel">
                            <h6>Conversión por carrera</h6>
                            <div v-if="performance.by_career.length" class="dashboard-admission-performance-list">
                                <div v-for="item in performance.by_career" :key="`career-${item.label}`" class="dashboard-admission-performance-row">
                                    <div>
                                        <span>{{ item.label }}</span>
                                        <small>{{ formatNumber(item.matriculados) }} / {{ formatNumber(item.total) }}</small>
                                    </div>
                                    <strong>{{ formatPercentage(item.conversion_rate) }}</strong>
                                    <div class="dashboard-admission-performance-track">
                                        <div :style="{ width: barWidth(item.total, performanceCareerMax) }"></div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="dashboard-admission-performance-empty">Sin datos de carrera.</div>
                        </div>
                    </div>
                    <div class="col-xl-4 mb-3">
                        <div class="dashboard-admission-performance-panel">
                            <h6>Conversión por coordinador</h6>
                            <p v-if="performance.current_week" class="small text-muted mb-2">
                                Semana vigente: {{ formatWeekDate(performance.current_week.start) }} — {{ formatWeekDate(performance.current_week.end) }} · lunes a domingo.
                                Según fecha de cierre HubSpot y última sincronización.
                            </p>
                            <div v-if="performance.by_owner.length" class="dashboard-admission-performance-list">
                                <div v-for="item in performance.by_owner" :key="`owner-${item.label}`" class="dashboard-admission-performance-row">
                                    <div>
                                        <span>{{ item.label }}</span>
                                        <small>{{ formatNumber(item.matriculados) }} / {{ formatNumber(item.total) }}</small>
                                        <small class="text-primary font-weight-bold">Esta semana: {{ item.matriculados_semana === null ? 'Sin dato' : formatNumber(item.matriculados_semana) }} matrículas</small>
                                    </div>
                                    <strong>{{ formatPercentage(item.conversion_rate) }}</strong>
                                    <div class="dashboard-admission-performance-track">
                                        <div :style="{ width: barWidth(item.total, performanceOwnerMax) }"></div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="dashboard-admission-performance-empty">Sin datos de coordinador.</div>
                        </div>
                    </div>
                    <div class="col-xl-4 mb-3">
                        <div class="dashboard-admission-performance-panel">
                            <h6>Conversión por fuente</h6>
                            <div v-if="performanceSourceGroups.length" class="dashboard-admission-performance-list">
                                <div v-for="item in performanceSourceGroups" :key="`source-${item.label}`" :class="['dashboard-admission-source-group', { 'has-children': item.children.length }]">
                                    <div class="dashboard-admission-performance-row dashboard-admission-source-parent">
                                        <div>
                                            <span>{{ item.label }}</span>
                                            <small>{{ formatNumber(item.matriculados) }} / {{ formatNumber(item.total) }}</small>
                                        </div>
                                        <strong>{{ formatPercentage(item.conversion_rate) }}</strong>
                                        <div class="dashboard-admission-performance-track">
                                            <div :style="{ width: barWidth(item.total, performanceSourceMax) }"></div>
                                        </div>
                                    </div>
                                    <div v-if="item.children.length" class="dashboard-admission-source-children">
                                        <div v-for="child in item.children" :key="`source-child-${child.label}`" class="dashboard-admission-performance-row dashboard-admission-source-child">
                                            <div>
                                                <span>{{ child.label }}</span>
                                                <small>{{ formatNumber(child.matriculados) }} / {{ formatNumber(child.total) }}</small>
                                            </div>
                                            <strong>{{ formatPercentage(child.conversion_rate) }}</strong>
                                            <div class="dashboard-admission-performance-track">
                                                <div :style="{ width: barWidth(child.total, performanceSourceMax) }"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="dashboard-admission-performance-empty">Sin datos de fuente.</div>
                        </div>
                    </div>
                </div>

                <div class="dashboard-admission-performance-panel dashboard-admission-owner-career-panel mb-3">
                    <div class="d-flex flex-wrap justify-content-between align-items-start mb-3">
                        <h6 class="mb-1">Carreras matriculadas por coordinador</h6>
                        <small class="text-muted">Distribución de matrículas dentro de cada coordinador</small>
                    </div>
                    <div v-if="performance.owner_careers.length" class="dashboard-admission-owner-career-list">
                        <div v-for="owner in performance.owner_careers" :key="`owner-career-${owner.label}`" class="dashboard-admission-owner-career-row">
                            <div class="dashboard-admission-owner-career-heading">
                                <span>{{ owner.label }}</span>
                                <strong>{{ formatNumber(owner.total) }}</strong>
                            </div>
                            <div class="dashboard-admission-owner-career-bars">
                                <div v-for="career in owner.careers" :key="`${owner.label}-${career.label}`" class="dashboard-admission-owner-career-item">
                                    <div class="dashboard-admission-owner-career-label">
                                        <span>{{ career.label }}</span>
                                        <small>{{ formatNumber(career.total) }} · {{ formatPercentage(career.percentage) }}</small>
                                    </div>
                                    <div class="dashboard-admission-performance-track">
                                        <div :style="{ width: barWidth(career.percentage, 100) }"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="dashboard-admission-performance-empty">Sin matrículas por coordinador para este filtro.</div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="dashboard-admission-performance-panel dashboard-admission-performance-chart-panel">
                            <h6>Día de matrícula</h6>
                            <div v-if="performance.matriculation_days.length" class="dashboard-admission-day-grid">
                                <div v-for="item in performance.matriculation_days" :key="item.day" class="dashboard-admission-day-card">
                                    <span>{{ item.day }}</span>
                                    <strong>{{ formatNumber(item.total) }}</strong>
                                    <div class="dashboard-admission-performance-track">
                                        <div :style="{ width: barWidth(item.total, performanceDayMax) }"></div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="dashboard-admission-performance-empty">Sin días de matrícula registrados.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>

<style scoped>
.dashboard-admission-direction-section,
.dashboard-admission-daily-section,
.dashboard-admission-controls-section,
.dashboard-admission-performance-section {
    border-radius: 7px;
}

.dashboard-admission-controls-section {
    background: #fbfcfe;
}

.dashboard-admission-controls-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
}

.dashboard-admission-controls-header h5 {
    color: #183b56;
    font-weight: 700;
}

.dashboard-admission-direction-section h4 {
    color: #183b56;
    font-weight: 700;
}

.dashboard-admission-filters {
    display: flex;
    gap: 10px;
}

.dashboard-admission-filters label {
    margin: 0;
}

.dashboard-admission-filters label span {
    display: block;
    color: #5f6b7a;
    font-size: 10px;
    font-weight: 800;
    line-height: 1;
    margin-bottom: 6px;
    text-transform: uppercase;
}

.dashboard-admission-filters .custom-select {
    min-width: 170px;
    height: 34px;
    border-color: #cbd8e6;
    color: #252c5f;
    font-size: 12px;
    font-weight: 700;
    background-color: #eef2fb;
}

.dashboard-admission-performance-controls {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
}

.dashboard-admission-performance-controls .custom-select {
    width: auto;
    min-width: 160px;
    height: 34px;
    border-color: #cbd8e6;
    color: #252c5f;
    font-size: 12px;
    font-weight: 700;
    background-color: #eef2fb;
}

.dashboard-admission-performance-controls .btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 34px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;
}

.dashboard-admission-kpi {
    border-radius: 7px;
    padding: 18px;
    min-height: 92px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #f8fafc;
    border: 1px solid #edf1f5;
}

.dashboard-admission-kpi span {
    color: #5f6b7a;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
}

.dashboard-admission-kpi strong {
    color: #183b56;
    font-size: 28px;
    line-height: 1;
}

.dashboard-admission-kpi-primary {
    background: #eef8f5;
    border-color: #cfece4;
}

.dashboard-admission-kpi-primary strong {
    color: #16836d;
}

.dashboard-admission-trend-panel {
    border-radius: 7px;
    padding: 18px;
    background: #fbfcfe;
    border: 1px solid #edf1f5;
}

.dashboard-admission-trend {
    min-height: 260px;
    display: flex;
    align-items: flex-end;
    gap: 8px;
    overflow-x: auto;
    padding: 12px 2px 0;
}

.dashboard-admission-trend-item {
    min-width: 42px;
    height: 240px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
}

.dashboard-admission-trend-bar {
    width: 28px;
    min-height: 18px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    border-radius: 6px 6px 0 0;
    background: #4ca4a1;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    padding-top: 4px;
}

.dashboard-admission-trend-item small {
    color: #5f6b7a;
    font-size: 10px;
    margin-top: 6px;
}

.dashboard-admission-empty {
    min-height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7a8794;
    border: 1px dashed #dbe5ee;
    border-radius: 7px;
    background: #f8fafc;
}

.dashboard-admission-section-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.dashboard-admission-section-header h5 {
    color: #183b56;
    font-weight: 700;
}

.dashboard-admission-daily-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.dashboard-admission-daily-actions .custom-select {
    min-width: 108px;
    height: 32px;
    border-color: #cbd8e6;
    color: #252c5f;
    font-size: 12px;
    font-weight: 700;
    background-color: #eef2fb;
}

.dashboard-admission-daily-actions .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    white-space: nowrap;
    min-width: 112px;
    min-height: 32px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;
}

.dashboard-admission-daily-status {
    border-radius: 7px;
    font-size: 12px;
    font-weight: 600;
}

.dashboard-admission-daily-grid {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 12px;
}

.dashboard-admission-daily-card {
    border-radius: 7px;
    padding: 16px;
    min-height: 126px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #fbfcfe;
    border: 1px solid #e6edf5;
}

.dashboard-admission-daily-card-header {
    min-height: 34px;
    display: flex;
    align-items: flex-start;
}

.dashboard-admission-daily-card span {
    color: #5f6b7a;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 1.25;
}

.dashboard-admission-daily-card strong {
    color: #183b56;
    font-size: 30px;
    line-height: 1;
    margin: 12px 0 14px;
}

.dashboard-admission-daily-track {
    height: 5px;
    border-radius: 999px;
    background: #edf1f5;
    overflow: hidden;
}

.dashboard-admission-daily-bar {
    height: 100%;
    border-radius: 999px;
    background: #5965a8;
}

.dashboard-admission-daily-warning {
    background: #fffaf3;
    border-color: #f1d6ad;
}

.dashboard-admission-daily-warning .dashboard-admission-daily-bar {
    background: #d9822b;
}

.dashboard-admission-daily-success {
    background: #f0faf6;
    border-color: #c8eadf;
}

.dashboard-admission-daily-success .dashboard-admission-daily-bar {
    background: #16836d;
}

.dashboard-admission-performance-summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
}

.dashboard-admission-performance-kpi,
.dashboard-admission-performance-panel {
    border-radius: 7px;
    background: #fbfcfe;
    border: 1px solid #e6edf5;
}

.dashboard-admission-performance-kpi {
    min-height: 92px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.dashboard-admission-performance-kpi span,
.dashboard-admission-performance-row span,
.dashboard-admission-day-card span,
.dashboard-admission-owner-career-heading span,
.dashboard-admission-owner-career-label span {
    color: #5f6b7a;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 1.25;
}

.dashboard-admission-performance-kpi strong {
    color: #183b56;
    font-size: 24px;
    line-height: 1.1;
}

.dashboard-admission-performance-panel {
    height: 100%;
    padding: 16px;
}

.dashboard-admission-performance-panel h6 {
    color: #183b56;
    font-size: 13px;
    font-weight: 800;
    margin-bottom: 14px;
}

.dashboard-admission-performance-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.dashboard-admission-performance-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    align-items: start;
}

.dashboard-admission-performance-row small {
    display: block;
    color: #7a8794;
    font-size: 11px;
    margin-top: 2px;
}

.dashboard-admission-performance-row strong {
    color: #183b56;
    font-size: 13px;
    font-weight: 800;
}

.dashboard-admission-source-group.has-children {
    border: 1px solid #e5ebf1;
    border-radius: 8px;
    background: #f8fafc;
    padding: 10px;
}

.dashboard-admission-source-group.has-children .dashboard-admission-source-parent span {
    color: #183b56;
    font-weight: 800;
}

.dashboard-admission-source-children {
    border-left: 2px solid #d7e1eb;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
    padding-left: 12px;
}

.dashboard-admission-source-child span::before {
    color: #8a99a8;
    content: "↳ ";
}

.dashboard-admission-owner-career-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
}

.dashboard-admission-owner-career-row {
    border: 1px solid #edf1f5;
    border-radius: 7px;
    background: #fff;
    padding: 12px;
}

.dashboard-admission-owner-career-heading {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 10px;
}

.dashboard-admission-owner-career-heading strong {
    color: #183b56;
    font-size: 14px;
    font-weight: 800;
}

.dashboard-admission-owner-career-bars {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.dashboard-admission-owner-career-label {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: flex-start;
    margin-bottom: 4px;
}

.dashboard-admission-owner-career-label small {
    color: #7a8794;
    font-size: 11px;
    white-space: nowrap;
}

.dashboard-admission-performance-track {
    grid-column: 1 / -1;
    height: 5px;
    border-radius: 999px;
    background: #edf1f5;
    overflow: hidden;
}

.dashboard-admission-performance-track div {
    height: 100%;
    border-radius: 999px;
    background: #4ca4a1;
}

.dashboard-admission-performance-chart-panel {
    min-height: 260px;
}

.dashboard-admission-day-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
}

.dashboard-admission-day-card {
    border-radius: 7px;
    padding: 12px;
    background: #f8fafc;
    border: 1px solid #edf1f5;
}

.dashboard-admission-day-card strong {
    display: block;
    color: #183b56;
    font-size: 22px;
    line-height: 1;
    margin: 10px 0;
}

.dashboard-admission-performance-empty {
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #7a8794;
    border: 1px dashed #dbe5ee;
    border-radius: 7px;
    background: #f8fafc;
    padding: 14px;
    font-size: 12px;
    font-weight: 600;
}

@media (max-width: 767.98px) {
    .dashboard-admission-controls-header {
        flex-direction: column;
    }

    .dashboard-admission-filters {
        width: 100%;
        flex-direction: column;
    }

    .dashboard-admission-filters label {
        width: 100%;
    }

    .dashboard-admission-filters .custom-select {
        width: 100%;
    }

    .dashboard-admission-performance-controls,
    .dashboard-admission-performance-controls .custom-select,
    .dashboard-admission-performance-controls .btn {
        width: 100%;
    }

    .dashboard-admission-performance-controls .btn {
        justify-content: center;
    }

    .dashboard-admission-section-header {
        flex-direction: column;
        gap: 10px;
    }

    .dashboard-admission-daily-actions,
    .dashboard-admission-daily-actions .custom-select,
    .dashboard-admission-daily-actions .btn {
        width: 100%;
    }

    .dashboard-admission-daily-actions {
        flex-direction: column;
    }

    .dashboard-admission-daily-actions .btn {
        justify-content: center;
    }

    .dashboard-admission-daily-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .dashboard-admission-performance-summary,
    .dashboard-admission-day-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .dashboard-admission-owner-career-list {
        grid-template-columns: 1fr;
    }

    .dashboard-admission-daily-card {
        min-height: 116px;
    }
}

@media (min-width: 768px) and (max-width: 1199.98px) {
    .dashboard-admission-daily-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .dashboard-admission-performance-summary {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (min-width: 1200px) and (max-width: 1539.98px) {
    .dashboard-admission-daily-grid {
        grid-template-columns: repeat(7, minmax(0, 1fr));
        gap: 10px;
    }

    .dashboard-admission-daily-card {
        padding: 14px;
        min-height: 118px;
    }

    .dashboard-admission-daily-card span {
        font-size: 10px;
    }

    .dashboard-admission-daily-card strong {
        font-size: 26px;
    }
}
</style>
